export const initialApproveFormData = {
  shift_schedule: [] as any,
  timesheet_entry: [] as any,
};
